import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import useMuses from "@/hooks/useMuses";
import MuseCard from "@/components/MuseCard";
import UpgradeModal from "@/components/UpgradeModal";

export default function Muses() {
  const nav = useNavigate();
  const { muses, example, limit, count, loading } = useMuses();
  const [upsell, setUpsell] = useState(false);
  const onNew = () => (count >= limit ? setUpsell(true) : nav("/muses/new"));
  return (
    <div>
      <div className="flex items-end justify-between gap-4 mb-10 fade-up">
        <div>
          <p className="eyebrow mb-3">Muse bible</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl">Muses</h1>
          <p className="muted text-sm mt-3" data-testid="muses-count">{count} of {limit} muse{limit > 1 ? "s" : ""} used</p>
        </div>
        <button className="btn-primary shrink-0" onClick={onNew} data-testid="muses-new-muse-button"><Plus size={16} /> New muse</button>
      </div>
      {loading ? <p className="muted text-sm">Loading…</p> : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-3 gap-4" data-testid="muses-grid">
            {muses.map((m, i) => <MuseCard key={m.id} muse={m} index={i} />)}
            {muses.length === 0 && (
              <button onClick={onNew} className="panel border-dashed aspect-[4/5] flex flex-col items-center justify-center gap-3 hover:border-[#9C4DDC] transition-colors" data-testid="muses-empty-new-tile">
                <Plus className="text-[#9C4DDC]" strokeWidth={1.25} size={32} />
                <span className="text-xs uppercase tracking-[0.15em] muted">Create your first muse</span>
              </button>
            )}
          </div>
          {example && (
            <div className="mt-14">
              <h2 className="text-base md:text-lg font-display mb-1">Example muse</h2>
              <p className="muted text-xs mb-5">A finished bible to learn from. Read-only.</p>
              <div className="grid grid-cols-2 lg:grid-cols-3 gap-4"><MuseCard muse={example} /></div>
            </div>
          )}
        </>
      )}
      <UpgradeModal open={upsell} onOpenChange={setUpsell} />
    </div>
  );
}
